import {Injectable} from '@angular/core';
import {HttpHandler, HttpInterceptor, HttpRequest,} from '@angular/common/http';

@Injectable()
export class CorsInterceptor implements HttpInterceptor {
    private whitelist: string[] = [
        'https://cloud-functions-api-gw-config-926xrm2x.wl.gateway.dev/API-Homologacion-DOT',
    ];
    constructor() {
    }
    intercept(req: HttpRequest<any>, next: HttpHandler) {
        console.log("CorsInterceptor ->CORS Habilitado");
        const shouldIgnore = this.whitelist.some(whitelistedUrl => req.url.includes(whitelistedUrl));
        if (shouldIgnore) {
            return next.handle(req); // Skip adding CORS header
        }
        const newRequest = req.clone({
            setHeaders: {
                'Access-Control-Allow-Origin': '*',
            }
        });
        return next.handle(newRequest);
    }
}
